"use strict";
// CRITICAL: This file is for BACKEND USE ONLY
// Psychology-informed response framing
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCommunityResources = exports.validateResponseLanguage = exports.FORBIDDEN_TERMS = exports.RESPONSE_TEMPLATES = exports.generateResponseFraming = void 0;
// Generate response framing based on psychological approach
const generateResponseFraming = (approach) => {
    const framings = {
        curiosity_validation: {
            tone: 'curious',
            approach: 'indirect',
            emphasizeValidation: true,
            includeAlternatives: true,
            communityResources: false
        },
        parental_empathy: {
            tone: 'empathetic',
            approach: 'supportive',
            emphasizeValidation: true,
            includeAlternatives: false,
            communityResources: true
        },
        economic_validation: {
            tone: 'respectful',
            approach: 'direct',
            emphasizeValidation: true,
            includeAlternatives: true,
            communityResources: false
        },
        social_proof: {
            tone: 'neutral',
            approach: 'indirect',
            emphasizeValidation: false,
            includeAlternatives: true,
            communityResources: true
        },
        authority_respect: {
            tone: 'respectful',
            approach: 'direct',
            emphasizeValidation: false,
            includeAlternatives: false,
            communityResources: false
        },
        gradual_evidence: {
            tone: 'neutral',
            approach: 'gradual',
            emphasizeValidation: false,
            includeAlternatives: true,
            communityResources: false
        },
        community_integration: {
            tone: 'empathetic',
            approach: 'supportive',
            emphasizeValidation: true,
            includeAlternatives: false,
            communityResources: true
        },
        personal_relevance: {
            tone: 'empathetic',
            approach: 'gradual',
            emphasizeValidation: true,
            includeAlternatives: true,
            communityResources: true
        }
    };
    return framings[approach];
};
exports.generateResponseFraming = generateResponseFraming;
// Generate dignity-preserving language templates
exports.RESPONSE_TEMPLATES = {
    curiosity_validation: {
        prefix: "That's an interesting perspective. I can see why you might think that. ",
        transition: "Let me share what I found when looking into this... ",
        suffix: "What do you think about these findings?"
    },
    parental_empathy: {
        prefix: "I understand your concerns - many people share these same worries. ",
        transition: "Here's what the current evidence shows... ",
        suffix: "I hope this information is helpful for your decision-making."
    },
    economic_validation: {
        prefix: "You're right to be thinking about the economic implications. ",
        transition: "The data I found shows... ",
        suffix: "This might help you evaluate the financial aspects."
    },
    social_proof: {
        prefix: "Many people have looked into this question. ",
        transition: "The consensus from multiple sources indicates... ",
        suffix: "This reflects what most experts in the field have concluded."
    },
    authority_respect: {
        prefix: "Looking at authoritative sources on this topic... ",
        transition: "The evidence indicates... ",
        suffix: "These findings come from established institutions."
    },
    gradual_evidence: {
        prefix: "Let me walk through what I found step by step. ",
        transition: "First, the evidence shows... Additionally... Finally... ",
        suffix: "Taken together, this suggests..."
    },
    community_integration: {
        prefix: "This is a topic many in our community have explored. ",
        transition: "What I've learned from various perspectives is... ",
        suffix: "You might find it helpful to connect with others who've researched this."
    },
    personal_relevance: {
        prefix: "I can see why this matters to you personally. ",
        transition: "Here's what might be most relevant to your situation... ",
        suffix: "I hope this helps you make the best decision for yourself."
    }
};
// NEVER use these words in responses (dignity-preserving principle)
exports.FORBIDDEN_TERMS = [
    'false',
    'debunked',
    'conspiracy theory',
    'misinformation',
    'disinformation',
    'fake news',
    'hoax',
    'lie',
    'wrong',
    'incorrect',
    'stupid',
    'ridiculous',
    'crazy',
    'delusional'
];
// Check if response contains forbidden terms
const validateResponseLanguage = (response) => {
    const lowerResponse = response.toLowerCase();
    return !exports.FORBIDDEN_TERMS.some(term => lowerResponse.includes(term.toLowerCase()));
};
exports.validateResponseLanguage = validateResponseLanguage;
// Generate follow-up community resources based on approach
const generateCommunityResources = (approach) => {
    if (!['parental_empathy', 'community_integration', 'personal_relevance'].includes(approach)) {
        return [];
    }
    return [
        {
            title: "Connect with Discerning Minds",
            url: "/community/discussions",
            type: "community",
            description: "Join thoughtful discussions with others exploring similar questions"
        },
        {
            title: "Find a Research Mentor",
            url: "/community/mentorship",
            type: "community",
            description: "Get guidance from experienced researchers in our community"
        }
    ];
};
exports.generateCommunityResources = generateCommunityResources;
//# sourceMappingURL=framing.js.map